import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex pa-4" };
import { ref } from 'vue';
import { userInfo } from '@/constants';
import { getGlobalStore } from '@/lib/global-store';
import hubStorage from '@/helpers/hubStorage';
import { useRouter } from 'vue-router';
import { routeName } from '@/constants/routeName';
const lc = 'views.hub_adjustment.';
const testMonth = '2024-03';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const router = useRouter();
        const hubId = ref('');
        const vuexStore = getGlobalStore();
        const handleClickTestModeBtn = () => {
            const hubInfo = {
                id: hubId,
                type: 'HUB',
                text: hubId,
            };
            vuexStore.dispatch('hubSelector/setSubscribeHubInfo', [
                hubInfo,
            ]);
            hubStorage.setSelectedHubInfo(hubInfo);
            hubStorage.setSessionItem({
                key: userInfo.IS_HUB_ADJUSTMENT_TEST_MODE,
                value: true,
            });
            router.push({
                name: routeName.HUB_ADJUSTMENT_MAIN,
            });
        };
        /** 세금계산서 테스트용 허브 리스트 */
        const hubList = [
            {
                hubId: 'B4488',
                info: '백경허브',
            },
            {
                hubId: 'B1925',
                info: '기타 수수료 존재 케이스1',
            },
            {
                hubId: 'B7583',
                info: '기타 수수료 존재 케이스2',
            },
            {
                hubId: 'B4915',
                info: '기타 수수료 존재 케이스3',
            },
            {
                hubId: 'B5773',
                info: '상점 관리비 케이스1',
            },
            {
                hubId: 'B1076',
                info: '상점 관리비 케이스2',
            },
            {
                hubId: 'B7588',
                info: '상점 관리비 케이스3',
            },
            {
                hubId: 'B0272',
                info: '기타 수수료 및 상점 관리비 모두 존재 및 보정 부가세 임의 추가 케이스1',
            },
            {
                hubId: 'B0318',
                info: '기타 수수료 및 상점 관리비 모두 존재 및 보정 부가세 임의 추가 케이스2',
            },
        ];
        const hubListForDev = [
            {
                hubId: 'B7171',
                info: '하준 개발 테스트용 M인천서구1총판',
            },
        ];
        const handleClickItem = (id) => {
            const hubInfo = {
                id,
                type: 'HUB',
                text: id,
            };
            vuexStore.dispatch('hubSelector/setSubscribeHubInfo', [
                hubInfo,
            ]);
            hubStorage.setSelectedHubInfo(hubInfo);
            hubStorage.setSessionItem({
                key: userInfo.IS_HUB_ADJUSTMENT_TEST_MODE,
                value: true,
            });
            router.push({
                name: routeName.HUB_ADJUSTMENT_MAIN,
                params: {
                    selectedMonth: [
                        testMonth,
                    ],
                },
            });
        };
        /** ********************** */
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle");
            const _component_v_list_item_content = _resolveComponent("v-list-item-content");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_list_item_group = _resolveComponent("v-list-item-group");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_card = _resolveComponent("v-card");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_text_field, {
                        modelValue: hubId.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((hubId).value = $event)),
                        placeholder: _ctx.$t(`${lc}test_mode_hub_id`),
                        variant: "outlined"
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        class: "ml-4",
                        onClick: handleClickTestModeBtn
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`${lc}test_mode_entrance_button`)), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                primary: true,
                                "size-xl": true
                            }
                        ]
                    ])
                ]),
                _createCommentVNode(" 세금계산서 테스트용 3월 바로가기 입니다 "),
                _createVNode(_component_v_card, {
                    flat: "",
                    outlined: "",
                    class: "pa-4 ma-4"
                }, {
                    default: _withCtx(() => [
                        _cache[1] || (_cache[1] = _createTextVNode(" # 세금계산서 테스트용 3월 바로가기 입니다. 누르면 바로 이동합니다. ")),
                        _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_list_item_group, {
                                    "active-class": "border",
                                    color: "indigo"
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(hubList, (item, i) => {
                                            return _createVNode(_component_v_list_item, {
                                                onClick: ($event) => (handleClickItem(item.hubId)),
                                                key: i
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, {
                                                                textContent: _toDisplayString(item.hubId)
                                                            }, null, 8 /* PROPS */, ["textContent"]),
                                                            (item.info)
                                                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                                    key: 0,
                                                                    textContent: _toDisplayString(item.info)
                                                                }, null, 8 /* PROPS */, ["textContent"]))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]);
                                        }), 64 /* STABLE_FRAGMENT */)),
                                        _createVNode(_component_v_divider, { class: "my-2" }),
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(hubListForDev, (item, i) => {
                                            return _createVNode(_component_v_list_item, {
                                                onClick: ($event) => (handleClickItem(item.hubId)),
                                                key: i
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_content, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, {
                                                                textContent: _toDisplayString(item.hubId)
                                                            }, null, 8 /* PROPS */, ["textContent"]),
                                                            (item.info)
                                                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                                    key: 0,
                                                                    textContent: _toDisplayString(item.info)
                                                                }, null, 8 /* PROPS */, ["textContent"]))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]);
                                        }), 64 /* STABLE_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */,
                    __: [1]
                }),
                _createCommentVNode(" ********** ")
            ]));
        };
    }
});
